import React, { useState } from "react"
import "../AnbarGardaniStyle.css";

const AnbargardaniStepOneSetting = (props) => {

    return (
        <React.Fragment>
            <div className="bg-white border" style={{ position: "absolute", top: "32px", right: "-5px", zIndex: 100, width: "200px" }}>
                {props.anbargardani && <div className="btn text-dark my-1 text-center w-100" onClick={props.anbargardani}>ویرایش انبارگردانی</div>}
                {props.location && <div className="btn my-1 text-dark text-center w-100" onClick={props.location}>ویرایش لوکیشن</div>}
                {props.exit && <div className="btn my-1 text-dark text-center w-100" onClick={props.exit}>خروج</div>}
            </div>

        </React.Fragment>
    )
}
export default AnbargardaniStepOneSetting;